<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "BidItem" });
import * as API from "../../services/api.js";
import { BID_STORE } from "../../services/store.js";
export let key;
export let onError = void 0;
const fetchBid = (key2) => {
    if (key2 === void 0) {
        return;
    }
    void API.fetchBid({ bidKey: key2 }, onError);
};
$: fetchBid(key);
</script>

{#if key !== undefined && key in $BID_STORE }

    <slot bid = { $BID_STORE[key] }>

        <pre>{ JSON.stringify($BID_STORE[key], null, 4) }</pre>

    </slot>

{/if}